import {getEditableFieldConfiguration} from "../editable-field.component";
import {IEditableField} from "../IEditableField";

export class PercentageEditableField extends IEditableField {

    public static instance = getEditableFieldConfiguration(
        require('./percentage-editable-field.html'),
        [PercentageEditableField]
    );


}